"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInferenceReportWithPostInferenceActionsSchema = exports.ISubModelInferenceReportEntrySchema = exports.InferenceReportSchema = exports.ComponentParameterInferenceReportSchema = void 0;
exports.applyInferenceReportEntriesToSignals = applyInferenceReportEntriesToSignals;
exports.applyInferenceReportEntriesToSignal = applyInferenceReportEntriesToSignal;
const SPICE_1 = require("../SPICE");
const zod_1 = require("zod");
const ComponentBoundaryInferenceReportEntry_1 = require("./ComponentBoundaryInferenceReportEntry");
const ComponentSignalInferenceReportEntry_1 = require("./ComponentSignalInferenceReportEntry");
const ComponentModeInferenceReportEntry_1 = require("./ComponentModeInferenceReportEntry");
const ComponentFunctionInferenceReportEntry_1 = require("./ComponentFunctionInferenceReportEntry");
const ComponentResourceInferenceReportEntry_1 = require("./ComponentResourceInferenceReportEntry");
const InferenceReportEntryBase_1 = require("./InferenceReportEntryBase");
exports.ComponentParameterInferenceReportSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.object({
    source: zod_1.z.string(),
    value: zod_1.z.any().optional(),
    disabled: zod_1.z.boolean().optional(),
}));
exports.InferenceReportSchema = zod_1.z.object({
    modes: zod_1.z.lazy(() => ComponentModeInferenceReportEntry_1.ComponentModeInferenceReportEntrySchema.array().optional()),
    boundaries: zod_1.z.lazy(() => ComponentBoundaryInferenceReportEntry_1.ComponentBoundaryInferenceReportEntrySchema.array().optional()),
    parameters: zod_1.z.lazy(() => exports.ComponentParameterInferenceReportSchema.optional()),
    signals: zod_1.z.lazy(() => ComponentSignalInferenceReportEntry_1.ComponentSignalInferenceReportEntrySchema.array().optional()),
    submodels: zod_1.z.lazy(() => exports.ISubModelInferenceReportEntrySchema.array().optional()),
    functions: zod_1.z.lazy(() => ComponentFunctionInferenceReportEntry_1.ComponentFunctionInferenceReportEntrySchema.array().optional()),
    resources: zod_1.z.lazy(() => ComponentResourceInferenceReportEntry_1.ComponentResourceInferenceReportEntrySchema.array().optional()),
});
exports.ISubModelInferenceReportEntrySchema = InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('model')
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default')),
    submodel: SPICE_1.ISubModelOptsSchema,
});
exports.IInferenceReportWithPostInferenceActionsSchema = exports.InferenceReportSchema.extend({
    postInferenceActions: zod_1.z
        .custom((value) => typeof value === 'function')
        .array()
        .optional(),
});
function applyInferenceReportEntriesToSignals(reportEntries, signals) {
    const resultSignals = signals.map((signal) => applyInferenceReportEntriesToSignal(reportEntries?.filter((e) => e.signalId === signal.id), signal));
    return resultSignals;
}
function applyInferenceReportEntriesToSignal(reportEntries, resultSignal) {
    reportEntries.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
    for (const entry of reportEntries) {
        if (entry.signalId !== resultSignal.id) {
            continue;
        }
        let metadata;
        if (resultSignal.metadata) {
            if (entry.properties.metadata) {
                metadata = {
                    ...resultSignal.metadata,
                    ...entry.properties.metadata,
                };
            }
            else {
                metadata = resultSignal.metadata;
            }
        }
        else if (entry.properties.metadata) {
            metadata = entry.properties.metadata;
        }
        let parametrics;
        if (resultSignal.parametrics) {
            if (entry.properties.parametrics) {
                parametrics = {
                    ...resultSignal.parametrics,
                    ...entry.properties.parametrics,
                };
            }
            else {
                parametrics = resultSignal.parametrics;
            }
        }
        else if (entry.properties.parametrics) {
            parametrics = entry.properties.parametrics;
        }
        resultSignal = {
            ...resultSignal,
            ...Object.fromEntries(Object.entries(entry.properties).filter(([, v]) => v !== undefined)),
            parametrics,
            metadata,
        };
    }
    return resultSignal;
}
//# sourceMappingURL=InferenceReports.js.map